import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { globals } from "../../globals";
import { Observable } from "rxjs";
import { QueryFilterService } from "./query-filter-service";
import { IGridifyQuery } from "gridify-client";
import { PaginatedModel } from "../../dominio/paginated-model";
import { TermoAceiteModel } from "src/app/dominio/termo-aceite-model";
import { TermoAceiteUsuarioModel } from "src/app/dominio/termo-aceite-usuario-model";


export class TermoAceiteGetOneResponse {
  result: TermoAceiteModel;
}

export class TermoAceiteGetManyResponse {
  results: TermoAceiteModel[];
  pagination: PaginatedModel;
}

export class TermoAceiteUsuarioGetManyResponse {
  results: TermoAceiteUsuarioModel[];
  pagination: PaginatedModel;
}

@Injectable({
  providedIn: 'root'
})
export class TermoAceiteService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {

  }

  buscarPorId(idTermoAceite: number): Observable<TermoAceiteGetOneResponse> {
    return this.http.get<TermoAceiteGetOneResponse>(`${globals.apiUrl}/api/v2/core/config/termos-aceite/${idTermoAceite}`);
  }

  buscarTodos(queryFilter: IGridifyQuery | null = null): Observable<TermoAceiteGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<TermoAceiteGetManyResponse>(`${globals.apiUrl}/api/v2/core/config/termos-aceite`, { params });
  }

  cadastrar(data: FormData): Observable<TermoAceiteGetOneResponse> {
    return this.http.post<TermoAceiteGetOneResponse>(
      `${globals.apiUrl}/api/v2/core/config/termos-aceite`,
      data
    );
  }

  atualizar(idTermoAceite: number, data: FormData): Observable<TermoAceiteGetOneResponse> {
    return this.http.put<TermoAceiteGetOneResponse>(
      `${globals.apiUrl}/api/v2/core/config/termos-aceite/${idTermoAceite}`,
      data
    );
  }

  excluir(idTermoAceite: number): Observable<void> {
    return this.http.delete<void>(
      `${globals.apiUrl}/api/v2/core/config/termos-aceite/${idTermoAceite}`
    );
  }

  baixarArquivo(idTermoAceite: number) {
    return this.http.get(`${globals.apiUrl}/api/v2/account/termos-aceite/${idTermoAceite}/arquivo`,
      { responseType: 'blob' });
  }

  aceitar(idTermo: number, usuarioTermo: string): Observable<void> {
    return this.http.post<void>(
      `${globals.apiUrl}/api/v2/account/termos-aceite/${idTermo}/aceitar`,
      { idTermo, usuarioTermo }
    );
  }

  buscarTermosAceitos(tipoUsuario: number, idUsuario: number, queryFilter: IGridifyQuery | null = null): Observable<TermoAceiteUsuarioGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter).set('tipoUsuario', tipoUsuario.toString()).set('idUsuario', idUsuario.toString());
    return this.http.get<TermoAceiteUsuarioGetManyResponse>(`${globals.apiUrl}/api/v2/core/termos-aceite`, { params });
  }

  buscarTodosTermos(tipoUsuario: number, idUsuario: number, queryFilter: IGridifyQuery | null = null): Observable<TermoAceiteUsuarioGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter).set('tipoUsuario', tipoUsuario.toString()).set('idUsuario', idUsuario.toString());
    return this.http.get<TermoAceiteUsuarioGetManyResponse>(`${globals.apiUrl}/api/v2/core/termos-aceite-carteira`, { params });
  }

  listarTermos(queryFilter: IGridifyQuery | null = null): Observable<TermoAceiteUsuarioGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<TermoAceiteUsuarioGetManyResponse>(`${globals.apiUrl}/api/v2/account/termos-aceite`, { params });
  }
}
